import { render, staticRenderFns } from "./capabilities.vue?vue&type=template&id=e8e49e6e&scoped=true&"
import script from "./capabilities.vue?vue&type=script&lang=js&"
export * from "./capabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e49e6e",
  null
  
)

export default component.exports